const SEND_EMAIL_SUCCESS_TEXT = "L'e-mail a bien été envoyé.";
export const SEND_EMAIL_SUCCESS = SEND_EMAIL_SUCCESS_TEXT;


// WEBPACK FOOTER //
// ./src/successes/marketing.js